<template>
    <div v-if="status">
        <radial-progress-bar :diameter="55" :completed-steps="completed1" :total-steps="total1" :stroke-width="4" :animate-speed="200" :inner-stroke-color="'white'">
            <template v-if="total2">
                <radial-progress-bar :diameter="45" :completed-steps="completed2" :total-steps="total2" :stroke-width="2" :animate-speed="50" :inner-stroke-color="'white'">
                    <template v-if="status==1"><img src="/icons/loading.gif" height="15"/></template>
                    <template v-if="status==2"><span class="text-danger glyphicon glyphicon-exclamation-sign"></span></template>
                </radial-progress-bar>
            </template>
            <template v-else>
                <template v-if="status==1"><img src="/icons/loading.gif" height="15"/></template>
                <template v-if="status==2"><h2><span class="text-danger glyphicon glyphicon-exclamation-sign "></span></h2></template>
            </template>
        </radial-progress-bar>
    </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
        props: ['completed1','total1','completed2','total2','status'],
        data: function(){
            return {};
        }
    }
</script>